module.exports = __webpack_public_path__ + "img/thematic_25.f1c6d36f.png";